import React from 'react';
import Icon1 from '../../images/fb_logo.png';
import Icon2 from '../../images/logo-szsem.png';
import Icon3 from '../../images/logo_zsem.png';
import Icon4 from '../../images/map.svg';
import { CardsContainer, CardsH1, CardsWrapper, Card, CardIcon, CardsH2, CardsP } from './ContactCardsElements';

const ContactCards = () => {
    return (
        <CardsContainer>
            <CardsH1>
                Gdzie możesz się skontaktować ze Stowarzyszeniem
            </CardsH1>
            <CardsWrapper>
                <Card href="https://www.facebook.com/SadeckiElektryk">
                    <CardIcon src={Icon1} />
                    <CardsH2>Facebook</CardsH2>
                    <CardsP>zobacz stronę FB</CardsP>
                </Card>
                <Card href="http://stowarzyszenie.zsem.edu.pl/">
                    <CardIcon src={Icon2} />
                    <CardsH2>Strona SZSEM</CardsH2>
                    <CardsP>zobacz stronę</CardsP>
                </Card>
                <Card href="https://zsem.edu.pl/">
                    <CardIcon src={Icon3} />
                    <CardsH2>Strona zsem</CardsH2>
                    <CardsP>zobacz stronę</CardsP>
                </Card>
                <Card href="https://goo.gl/maps/CHVt75BHrWYKJW7Z8">
                    <CardIcon src={Icon4} />
                    <CardsH2>Adres</CardsH2>
                    <CardsP>zobacz adres</CardsP>
                </Card>
            </CardsWrapper>
        </CardsContainer>
    )
}

export default ContactCards
